<div class="grid grid-cols-3 gap-5 auto-rows-fr h-44">
  <div class="flex flex-col flex-1 gap-4 h-full justify-center items-end">
    <div class="flex flex-col gap-2 text-end">
      <p class="m-0 text-brand-bright-orange text-xs font-semibold leading-none " *ngIf="dataCompare?.totalMen">
        {{timeframeType}}
      </p>
      <div class="flex flex-col pr-2 border-r-4 gap-1 border-brand-chathams-blue">
        <h3 class=" mb-0 text-lg font-semibold leading-none">{{data?.totalMen | numberFormat}}</h3>
        <p class="mb-0 text-sm text-gray-800 leading-none">{{'peopleCount.men' | translate}}</p>
      </div>
    </div>

    <div class="flex flex-col gap-2 text-end" *ngIf="dataCompare?.totalMen">
      <p class="m-0 text-brand-bright-orange text-xs font-semibold leading-none text-wrap">
        {{'peopleCount.weekToCompare' | translate}}
      </p>
      <div class="flex flex-col pr-2 border-r-4 gap-1 border-chathams-blue-400">
        <h3 class=" mb-0 text-lg font-semibold leading-none">{{dataCompare?.totalMen | numberFormat}}</h3>
        <p class="mb-0 text-sm text-gray-800 leading-none">{{'peopleCount.men' | translate}}</p>
      </div>
    </div>
  </div>

  <div class="relative flex flex-1 flex-col items-center">
    <canvas
      class="m-0"
      [data]="doughnutChartData"
      [options]="doughnutChartOptions"
      [type]="'doughnut'"
      [plugins]="chartDoughnutPlugins"
      baseChart></canvas>
  </div>

  <div class="flex flex-col flex-1 gap-4 h-full justify-center items-start">
    <div class="flex flex-col gap-2">
      <p class="m-0 text-brand-bright-orange text-xs font-semibold leading-none text-wrap" *ngIf="dataCompare?.totalWomen">
        {{timeframeType}}
      </p>
      <div class="flex flex-col pl-2 border-l-4 gap-1 border-brand-bright-orange">
        <h3 class=" mb-0 text-lg font-semibold leading-none">{{data?.totalWomen | numberFormat}}</h3>
        <p class="mb-0 text-sm text-gray-800 leading-none">{{'peopleCount.women' | translate}}</p>
      </div>
    </div>
    <div class="flex flex-col gap-2" *ngIf="dataCompare?.totalWomen">
      <p class="m-0 text-brand-bright-orange text-xs font-semibold leading-none ">{{'peopleCount.weekToCompare' | translate}}</p>
      <div class="flex flex-col pl-2 border-l-4 gap-1 border-orange-400">
        <h3 class=" mb-0 text-lg font-semibold leading-none">{{dataCompare?.totalWomen || 0 | numberFormat}}</h3>
        <p class="mb-0 text-sm text-gray-800 leading-none">{{'peopleCount.women' | translate}}</p>
      </div>
    </div>
  </div>
</div>